/**
 * Created by Dhanya Akhil on 3/31/2017.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MaintenanceApi } from './api/maintenance.api';

@Injectable()
export class MaintenanceResourceService {
  constructor(private maintenanceApi:MaintenanceApi) {
  }

  inMaintenance():Observable<any> {
    return this.maintenanceApi.getStatus();
  }
}
